import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  declare urlValue: string

  connect(): void {
    // Small delay to ensure Turbo Stream WebSocket subscription is established
    setTimeout(() => this.startAssessment(), 500)
  }

  private async startAssessment(): Promise<void> {
    const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')!.content
    await fetch(this.urlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": csrfToken }
    })
  }
}
